'use client';
import { useState } from 'react';
import { StockStoryDrawer } from './StockStoryDrawer';

/**
 * Click-target that opens the per-stock "Why?" drawer.
 * Drop next to any ticker — holdings tables, recommended list, alpha basket entries.
 *
 * Stops click propagation so it can live inside row-buttons without triggering
 * the parent (e.g. expand-row / open-stock-detail).
 */
export function StockStoryButton({ symbol, className = '' }: { symbol: string; className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title={`Why ${symbol}? — open story`}
        aria-label={`Open story for ${symbol}`}
        className={`inline-flex items-center justify-center text-[#475569] hover:text-amber-300 text-[10px] font-bold leading-none px-0.5 transition-colors ${className}`}
      >
        ⓘ
      </button>
      {open && <StockStoryDrawer symbol={symbol} onClose={() => setOpen(false)} />}
    </>
  );
}
